import axios from "axios";
import { useCallback, useState } from "react";
import { getBackendUrl } from "../../../../../../util/envFn";
import { Todo, TodoCreateData } from "../../../../types/types";
import { API_PREFIX_TODOS } from "../../constants";

const useTodoList_Server = (currentWorkspaceId: string | null, listRefresher: () => void) => {
    const createTodo = async (title?: string, listId?: string): Promise<Todo> => {
        const response = await axios.post(getBackendUrl(`${API_PREFIX_TODOS}/${listId}`),
            { text: title ?? 'New Todo' });
        updatedRefresh();
        return response.data;
    };

    //TODO
    const createTodoByTodoData = async (todoData: TodoCreateData, listId?: string): Promise<Todo> => {
        const response = await axios.post(getBackendUrl(`${API_PREFIX_TODOS}/${listId}`), todoData);
        updatedRefresh();
        return response.data;
    };

    const getTodos = useCallback(async (): Promise<Todo[]> => {
        if (!currentWorkspaceId) return [];

        const response = await axios.get(getBackendUrl(`${API_PREFIX_TODOS}/${currentWorkspaceId}`));
        return response.data;
    }, [currentWorkspaceId]);

    const deleteTodo = async (todoId: string): Promise<boolean> => {
        const response = await axios.delete(getBackendUrl(`${API_PREFIX_TODOS}/${todoId}`));
        updatedRefresh();
        return !!response.data;
    };

    const updateTodo = async (todoId: string, todo: Partial<Todo>): Promise<Todo | null> => {
        const response = await axios.put(getBackendUrl(`${API_PREFIX_TODOS}/${todoId}`), todo);
        updatedRefresh();
        return response.data;
    };

    const toggleTodo = async (todoId: string): Promise<boolean> => {
        const response = await axios.put(getBackendUrl(`${API_PREFIX_TODOS}/${todoId}/toggle`));
        updatedRefresh();
        return !!response.data;
    };

    const moveTodoToList = async (todoId: string, sourceListId: string, destinationListId: string, destinationIndex: number): Promise<boolean> => {
        const response = await axios.put(getBackendUrl(`${API_PREFIX_TODOS}/${todoId}/move`), {
            sourceListId,
            destinationListId,
            destinationIndex
        });
        updatedRefresh();
        return !!response.data;
    };

    const [todos, setTodos] = useState<Todo[]>([]);
    const [todosMap, setTodosMap] = useState<Map<string, Todo>>(new Map());

    const updatedRefresh = useCallback(async () => {
        try {
            const todos = await getTodos();
            listRefresher();
            setTodos(todos);
            setTodosMap(new Map(todos.map(todo => [todo.id, todo])));
        } catch (error) {
            // console.error("Error refreshing todo lists:");
        }
    }, [getTodos, listRefresher]);

    const refresh = useCallback(async () => {
        try {
            const todos = await getTodos();
            setTodos(todos);
            setTodosMap(new Map(todos.map(todo => [todo.id, todo])));
        } catch (error) {
            // console.error("Error refreshing todo lists:");
        }
    }, [getTodos]);

    const clear = useCallback(async () => {
        setTodos([]);
        setTodosMap(new Map());
    }, []);

    return {
        refresh,
        clear,
        todos,
        todosMap,
        createTodo,
        createTodoByTodoData,
        updateTodo,
        deleteTodo,
        toggleTodo,
        moveTodoToList,
    }
}

export default useTodoList_Server;